<app-header
  [profile]="profile"
  [isAuthenticated]="isAuthenticated"
  (login)="login()"
  (logout)="logout()"
></app-header>

<div class="app-body">
  <app-sidebar
    [isAuthenticated]="isAuthenticated"
    [permissions]="profile?.permissions"
  ></app-sidebar>

  <main role="main" class="main">
    <div class="container-fluid"><router-outlet></router-outlet></div>
  </main>
</div>
